module.exports = __webpack_public_path__ + "static/fonts/lato-v23-latin-ext_latin-100.4fff93f.ttf";